<template>
  <div class="accept-obnl-membership-section">
    <h3 class="text-left font-weight-normal">
      {{ $t("views.register.step.community.membership_section_title") }}
    </h3>

    <b-form-checkbox class="mb-2" @input="$emit('input', $event)">
      {{ $t("views.register.step.community.membership") }}
    </b-form-checkbox>

    <div class="mb-2">
      <b-button v-b-toggle.obnl-membership-activity variant="link" class="p-0 text-left">
        {{ $t("views.register.step.community.membership_question_title") }}
      </b-button>

      <b-collapse id="obnl-membership-activity" class="mt-3">
        <div>
          <p>{{ $t("views.register.step.community.membership_details.1") }}</p>

          <p class="mb-1">{{ $t("views.register.step.community.membership_details.2") }}</p>

          <ul>
            <li>
              {{ $t("views.register.step.community.membership_details.list.heading") }}
              <ul>
                <li>
                  {{ $t("views.register.step.community.membership_details.list.1") }}
                </li>
                <li>
                  {{ $t("views.register.step.community.membership_details.list.2") }}
                </li>
                <li>
                  {{ $t("views.register.step.community.membership_details.list.3") }}
                </li>
              </ul>
            </li>
            <li>
              {{ $t("views.register.step.community.membership_details.list.4") }}
            </li>
          </ul>

          <p>{{ $t("views.register.step.community.membership_details.3") }}</p>
        </div>
      </b-collapse>
    </div>

    <div class="accept-obnl-membership-section__warning text-danger">
      <span v-if="!value">
        {{ $t("views.register.step.community.membership_warning") }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  value: boolean;
}>();

defineEmits<{
  (e: "input", payload: boolean): [boolean];
}>();

import { useI18n } from "vue-i18n-composable";

const { t: $t } = useI18n();
</script>

<style lang="scss">
.accept-obnl-membership-section {
  &__warning {
    height: 1.2rem;
  }
}
</style>
